import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import queryClient from "@onesolution/components/ProvidersWrapper/queryClient";
import { USER_ROLES } from "@onesolution/constants";
import { authMiddleware, mondayBoards } from "@onesolution/middlewares";
import { rolesCheck } from "@onesolution/middlewares/rolesCheck";
import { formatUserColumnsForMutation } from "@onesolution/monday/format";
import { mondayClient } from "@onesolution/monday/monday";
import { wrapWithUseMutation } from "..";

const _UserMutationParams = z.object({
	id: z.string().nullable().optional(),
	email: z.string(),
	firstname: z.string(),
	lastname: z.string(),
	role: z.string(),
	language: z.string(),
	active: z.boolean(),
	services: z.array(z.string()).nullable().optional(),
	favoriteServices: z.array(z.string()).nullable().optional(),
});

export const UserMutationParams = _UserMutationParams;
export type UserMutationVariables = z.infer<typeof UserMutationParams>;

const handle = createServerFn({ method: "POST" })
	.middleware([authMiddleware, mondayBoards, rolesCheck([USER_ROLES.Admin])])
	.validator(_UserMutationParams)
	.handler(async ({ context, data }) => {
		const columnValues = formatUserColumnsForMutation(data);

		return mondayClient.mutation.createItem({
			boardId: context.boards.users,
			itemName: data.email,
			columnValues: JSON.stringify(columnValues),
		});
	});

export const createUserOnServer = wrapWithUseMutation(handle, {
	onSuccess: () => {
		queryClient.invalidateQueries({ queryKey: ["users"] });
	},
});
